// TODO find a way to share with the server's type names
export const MediaTypes = Object.freeze({
  Unknown: 0,
  Article: 1,
  Book: 2,
  Video: 3,
  Diagram: 4,
  Website: 5,
  Code: 6,
  Tool: 7,
  Digest: 8,
  Paper: 9,
  Discussion: 10,
  Course: 11,
  Music: 12,
  Episode: 13,
  Presentation: 14,
  YouTubeChannel: 15,
  Podcast: 16,
});

export const mediaTypeLabels = [
  {
    value: MediaTypes.Unknown,
    name: 'unknown',
    label: 'Unknown',
  },
  {
    value: MediaTypes.Article,
    name: 'article',
    label: 'Article',
    color: 'green',
  },
  {
    value: MediaTypes.Book,
    name: 'book',
    label: 'Book',
    color: 'purple',
  },
  {
    value: MediaTypes.Video,
    name: 'video',
    label: 'Video',
    color: 'red',
  },
  {
    value: MediaTypes.Diagram,
    name: 'diagram',
    label: 'Diagram',
    color: '#283593',
  },
  {
    value: MediaTypes.Website,
    name: 'website',
    label: 'Website',
    color: '#162032',
  },
  {
    value: MediaTypes.Code,
    name: 'code',
    label: 'Code',
    color: '#0d1b2a',
  },
  {
    value: MediaTypes.Tool,
    name: 'tool',
    label: 'Tool',
    color: '#1a237e',
  },
  {
    value: MediaTypes.Digest,
    name: 'digest',
    label: 'Digest',
    color: 'teal',
  },
  {
    value: MediaTypes.Paper,
    name: 'paper',
    label: 'Paper',
    color: '#4a148c',
  },
  {
    value: MediaTypes.Discussion,
    name: 'discussion',
    label: 'Discussion',
    color: '#e65100',
  },
  {
    value: MediaTypes.Course,
    name: 'course',
    label: 'Course',
    color: '#6a1b9a',
  },
  {
    value: MediaTypes.Music,
    name: 'music',
    label: 'Music',
    color: '#00838f',
  },
  {
    value: MediaTypes.Episode,
    name: 'episode',
    label: 'Episode',
    color: '#1565c0',
  },
  {
    value: MediaTypes.Presentation,
    name: 'presentation',
    label: 'Presentation',
    color: '#bf360c',
  },
  {
    value: MediaTypes.YouTubeChannel,
    name: 'channel',
    label: 'Channel',
    color: '#b71c1c',
  },
  {
    value: MediaTypes.Podcast,
    name: 'podcast',
    label: 'Podcast',
    color: '#0277bd',
  },
];

export function buildMediaTypeNameMap() {
  const result = {};
  mediaTypeLabels.forEach((type) => {
    result[type.value] = type;
  });
  return result;
}

const VALUE_BY_NAME = {};
mediaTypeLabels.forEach((type) => { VALUE_BY_NAME[type.name] = type.value; });

// The name a type travels under in a URL (`?type=video`).
export function mediaTypeName(value) {
  return mediaTypeLabels.find((type) => type.value === value)?.name || null;
}

// The numeric media type a URL param stands for, or null - the server reads the
// same names (`shared/src/utils/typeNames.js`).
export function parseMediaType(raw) {
  const name = String(raw ?? '').trim().toLowerCase();
  return Object.hasOwn(VALUE_BY_NAME, name) ? VALUE_BY_NAME[name] : null;
}
